import { useEffect } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useTagStaffStore } from '../../../../../../store/use-tag-staff-store';

export const useShiftsControls = () => {
  const { t, getLocale } = useLang();
  const { place: branches, fetchBranches } = useBranchesStore();
  const { tags: tag, fetchTags } = useTagStaffStore();
  const scheduleModal = useModalParams('shiftsSchedule');
  const scheduleNotificationsModal = useModalParams('scheduleNotifications');

  useEffect(() => {
    fetchBranches({ is_by_company: true, n: 1000, since_id: 0 });
    fetchTags({ is_by_company: true, n: 1000, since_id: 0 });
  }, []);

  return {
    t,
    scheduleModal,
    scheduleNotificationsModal,
    branches,
    tag,
    getLocale,
  };
};
